<div style="width:95%;min-width: 500px;" *ngIf="types.length > 0">
  <span> <button class="btn btn border" (click)="saveSign()">Spara</button> <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
  <br>
  <hr />
  <br>
  <form [formGroup]="form">
    <div class="col-md-6">
      <label>
        Förkortning
      </label>
      <input id="abbreviation" type="text" class="form-control form-control-sm" formControlName="abbreviation">
    </div>
    <div class="col-md-6">
      <label>
        Namn
      </label>
      <input id="name" type="text" class="form-control form-control-sm" formControlName="name">
    </div>
    <div class="col-md-6">
      <label>
        Typ
      </label>
      <p-select *ngIf="types.length > 0" appendTo="body" [options]="types" formControlName="type" [style]="{'width':'100%', 'height':'40px'}" (onChange)="setType($event)"></p-select>
    </div>
    <div class="col-md-2">
      <label>
        Sorteringsordning
      </label>
      <input id="sort" type="text" class="form-control form-control-sm" formControlName="sort">
    </div>
  </form>
</div>
